<!--此页面为直播预告详情页和回放详情页，通过route的type==='replay'来区分，两个页面接口部分字段不一样，需要中间处理统一-->
<template>
  <div class="preview-container">
    <Collection @click="switchVideo" v-if="collectionList.length" :list="collectionList" :idx="currentCollectionIdx"/>
    <!--预告是视频还是图片  回放页面只有视频-->
    <div v-if="details.video || isReplay" class="pre-video prism-player" id="J_prismPlayer_previewDetails"></div>
    <img v-else class="pre-img" :src="details.img" alt="壹心理">

    <!--未播放预告视频前显示预告图片-->
    <div v-show="details.videoPreImg && ((details.video && beforePlay) || isCourse)" class="prevideo-img">
      <img :src="details.videoPreImg" alt="壹心理">
    </div>

    <!--预告播放按钮显示-->
    <!-- <img v-show="!isPlay && details.video && !isCourse" class="play-img" src="../../assets/images/play.png" alt="壹心理-直播预告"> -->

    <div class="pre-content">
      <!--预告倒计时  回放隐藏倒计时-->
      <div v-if="!isReplay && !isCourse" class="preview-time-container">
        <div class="time-left-con">
          <div class="preview-tag">预告</div>
          <div>
            <span class="time-box">{{ +timeObj.day < 10 ? '0' + timeObj.day : timeObj.day }}</span>天<span class="time-box">{{ timeObj.hou }}</span>:<span class="time-box">{{ timeObj.min }}</span>:<span class="time-box">{{ timeObj.sec }}</span>
          </div>
        </div>
        <div v-if="!isCourse" class="func-btn" :class="details.alreadyClickRemind ? 'oval-box1' : 'oval-box2'" @click="handleRemind">{{ details.alreadyClickRemind ? '已提醒' : '开播提醒' }}</div>
      </div>

      <section v-if="!isCourse" ref="section" class="section">
        <div ref="sectionBottom" class="section-bottom">
          <!--频道头像名称-->
          <avatar-name-con
            :channelId="details.channelId"
            :name="details.channelName"
            :avatar="details.channelAvatar"
            :isFollow="details.alreadyFollow"
            :hideBtn="!!isCourse || isToufangLive"
            @handleAttention="handleAttention"
            />

          <!--简介-->
          <div class="text-container">
            <p :class="['title', {special}]">{{ details.title || '' }}</p>
            <p ref="richText" class="rich-text" style="line-height: 24px" :class="{'expand-text': !isExpand}" v-html="details.intro"></p>
            <span v-if="ifShowExpand" class="operate-btn func-btn" @click="handleExpandBtn">{{ isExpand ? '收起' : '展开' }}</span>
          </div>

          <section v-if="isToufangLive" class="preview-fun-container">
            <!-- <div class="btn-group func-btn bottom-group-comment-only">
              <div class="bottom-btn func-btn" @click="showComment()">
                <div v-if="details.commentNum" class="num func-btn">{{ details.commentNum | millionNum  }}</div>
                <img class="func-btn" src="../../assets/images/comment.png" alt="壹心理直播-评论">
              </div>
            </div> -->
          </section>
          <!--如果有课程lessonId，则为付费直播，隐藏操作栏-->
          <div v-else-if="!isCourse" class="preview-fun-container" v-open-app="openAppConfig">
            <!--主播邀你来观看直播-->
            <template v-if="viewable">
              <div v-if="isReplay" class="replay-btn func-btn" @click="goToAppReplay">
                去壹心理App观看精彩视频
                <svg-icon icon-class="arrow" class-name="func-btn"></svg-icon>
              </div>
              <div v-else class="left-btn func-btn" @click="watchClick">
                去壹心理App围观直播
                <svg-icon icon-class="arrow" class-name="func-btn"></svg-icon>
              </div>
            </template>
            <Deblocking v-else class="func-btn" :isReplay="isReplay" :handlewxLogin="handlewxLogin" :groupQrcode="groupQrcode" :deblockId="deblockId" :pageTitle="details.title" />

            <div class="btn-group func-btn">
              <!--解梦申请-->
              <div v-show="!details.advanceConnect && details.advanceDream && !isReplay" class="bottom-btn func-btn" @click="dreamApply">
                <img src="../../assets/images/moon.png" alt="壹心理直播-解梦申请">
                <img class="tag" src="../../assets/images/dream.png" alt="壹心理直播-解梦申请">
              </div>

              <!--连麦申请-->
              <div v-show="details.advanceConnect && !isReplay" class="bottom-btn func-btn" @click="microConnectApply">
                <img src="../../assets/images/microphone.png" alt="壹心理直播-连麦申请">
                <img class="tag" src="../../assets/images/micro.png" alt="壹心理直播-连麦申请">
              </div>

              <!--点赞-->
              <div class="bottom-btn func-btn" @click="likeClick">
                <div v-if="details.likeNum" class="num func-btn">{{ details.likeNum | millionNum }}</div>
                <img class="func-btn" src="../../assets/images/isLike.png" alt="壹心理直播-点赞">
              </div>

              <!--评论-->
              <div class="bottom-btn func-btn" @click="showComment()">
                <div v-if="details.commentNum" class="num func-btn">{{ details.commentNum | millionNum  }}</div>
                <img class="func-btn" src="../../assets/images/comment.png" alt="壹心理直播-评论">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!--付费课程拦截提示-->
    <section v-if="isCourse" class="course-con">
      <join-course :lesson-id="details.lessonId" :money="coursePrice"></join-course>
    </section>

    <!--开播提醒弹窗-->
    <dialog-tip v-if="previewDialog" @close="closePreviewDialog">
      <template>
        <div class="dialog-content">
          <p class="conteng-title">预约成功</p>
          <p class="content-subheading" v-show="details.liveTime">开播时间：
            <span>{{ liveTime.month }}</span>月
            <span>{{ liveTime.day }}</span>日&nbsp;
            <span>{{ liveTime.hour }}:{{ liveTime.min }}</span>
          </p>
          <p class="content-tip">微信内扫描或长按识别二维码，<br/>关注公号，第一时间掌握直播资讯</p>
          <div class="content-scan">
            <img class="scan-img" src="../../assets/images/scan.jpg" alt="壹心理-公开课">
          </div>
        </div>
      </template>
    </dialog-tip>

    <!--关注主播弹窗-->
    <dialog-tip v-if="attentionDialog" @close="closeAttentionDialog">
      <template>
        <div class="dialog-content">
          <p class="conteng-title">你已关注主播</p>
          <p class="content-tip">微信内扫描或长按识别二维码，<br/>关注公号，第一时间掌握Ta的直播资讯</p>
          <div class="content-scan">
            <img class="scan-img" src="../../assets/images/scan.jpg" alt="壹心理-公开课">
          </div>
        </div>
      </template>
    </dialog-tip>

    <!--前往App查看完整回放弹窗-->
    <!-- <dialog-tip v-if="replayDialog" :showClose="false" :hasBtnGroup="true" @btn1Fun="closeReplayDialog">
      <template>
        <div class="dialog-content">
          <p class="replay-tip">前往App查看完整回放</p>
        </div>
      </template>
      <template v-slot:btn2>
        <div class="copyBtn" @click="replayConfirmBtn">确定</div>
      </template>
    </dialog-tip> -->

    <!--评论弹窗-->
    <Dialog v-if="commentDialog" @close="commentDialog = false">
      <template v-slot:dialogTop>
        <p class="comment-top-title">共{{ details.commentNum || 0 }}条评论</p>
      </template>
      <template v-slot:dialogContent>
        <comment :comment-list="commentList" :live-title="details.liveTitle">
          <div class="comment-tip">
            <p v-if="commentList.length >= pageSize && !finish && !loading" @click="getCommentList">点击查看更多</p>
            <p v-else-if="loading && !finish">加载中</p>
            <p v-else>没有更多评论</p>
          </div>
        </comment>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import AvatarNameCon from 'components/AvatarNameCon'
  import Comment from "./comment";
  import Collection from "./collection";
  import Deblocking from 'components/Deblocking';
  import Dialog from 'components/Dialog';
  import DialogTip from 'components/DialogTip'
  import { wx, downloadApp, countDown, pagination, wxShare, fitVideo, shareBind, viewable } from 'mixins'
  import { foreshow, getCommentList, remind, starChannel, getReplayDetails, getCollectionList, getLiveDetail, liveRecordedView } from 'api/live'
  import { getToken, getUserId, getOpenId, aliplayerReadyHandle, isWifi, timeSplit, centToYuan } from '@/utils/utils'
  import JoinCourse from "../../components/JoinCourse/index";
  import { getStorage } from '@/utils/storage'

  const REPLAY = ['replay', 'collection']

  export default {
    name: "PreviewDetails",
    components: {
      JoinCourse,
      Dialog,
      DialogTip,
      Comment,
      Collection,
      Deblocking,
      AvatarNameCon
    },
    data() {
      return {
        isReplay: false, // 是否回放，预告详情页与回放详情页的区分
        isCollection: false,
        currentCollectionIdx: 0,
        groupQrcode: '',
        encodeCommand: { // 口令参数
          title: '',
          desc: '',
          channelName: '',
          url: ''
        },
        liveId: 0,
        deblockId: 0,
        details: { // 预告与回放字段统一
          video: '', // 视频
          videoPreImg: '', // 列表图
          img: '', // 预告图
          likeNum: '',
          commentNum: '',
          dream: '',
          title: '',
          intro: '', // 简介
          channelId: 0,
          channelName: '',
          channelAvatar: '',
          alreadyFollow: '',
          alreadyClickRemind: ''
        },
        collectionList: [],
        live: {},
        liveTime: {},
        isCountEnd: false,
        commentDialog: false,
        attentionDialog: false,
        previewDialog: false,
        replayDialog: false,
        commentList: [],
        isExpand: true,
        ifShowExpand: false, // 是否显示展开收起
        aliplayer: null,
        finish: false,
        loading: false,
        beforePlay: true, // 首次播放前的图片显示
        isPlay: false, // 播放状态
        wifiTips: false, // 首次点击播放4g下提示消耗流量
        liveType: -1,
        playTime: ''
      }
    },
    mixins: [wx, downloadApp, countDown, pagination, wxShare, fitVideo, shareBind, viewable],
    async created() {
      this.deblockId = this.liveId = this.$route.query.id
      this.freeCode = this.$route.query.free_code

      const type = this.$route.query.type
      this.isReplay = REPLAY.includes(type)
      this.isCollection = type === REPLAY[1]

      if (this.freeCode && !getToken()) {
        this.handlewxLogin()
      }

      if (window.$platform.isWechat) {
        await this.handlewxLogin()
      }

      /*预告和回放接口不同*/
      if (this.isReplay) {
        document.title = '回放详情'
        this.fetchReplayData()
      } else {
        this.fetchData()
      }

      if (this.isCollection) {
        this.fetchCollectionList()
      }
    },
    watch: {
      // 控制蒙版高度
      isExpand: {
        handler: function () {
          this.$nextTick(() => {
            const height = this.$refs.sectionBottom.offsetHeight
            this.$refs.section.setAttribute('style', `height: ${height + 80}px`)
          })
        },
        immediate: true
      },
      currentCollectionIdx(index) {
        this.initialization = true
        this.liveId = this.collectionList[index].id

        this.commentDialog = false
        this.loading = false
        this.finish = false
        this.pageNo = 1
        this.commentList = []

        this.fetchReplayData()
      }
    },
    computed: {
      userInfo() {
        return this.loginClass.userInfo || {}
      },

      isFromAssistant() {
        return this.$route.query.from === 'assistant'
      },

      coursePrice() {
        return centToYuan(this.details.coursePrice)
      },
      isCourse() {
        return +this.details.lessonId
      },
      type() {
        return this.isReplay ? 3 : 1
      },
      collectionId() {
        return this.$route.query.collectionId
      },
      openAppConfig() {
        let appUrl = ""
        if (this.isReplay) {
          appUrl = `yixinli://open_live_replay?replay_id=${this.liveId}&collection_id=${this.collectionId}`
        } else {
          appUrl = `yixinli://open_live_notice?live_id=${this.liveId}`
        }
        return {
          type: 'act',
          url: appUrl,
          errIosUrl: "https://sdata.xinli001.com/r/ua",
          errAndroidUrl: "https://sdata.xinli001.com/r/ua"
        }
      },
      isToufangLive() {
        return this.liveType === 7
      }
    },
    methods: {
      /*获取回放详情页接口*/
      fetchReplayData() {
        let token = getToken()
        getReplayDetails({
          replayId: this.liveId,
          token,
          code: this.freeCode
        }).then(res => {
          if (+res.code === 0) {
            const data = res.data
            this.details = {
              video: data.url,
              videoPreImg: data.advanceImg,
              likeNum: data.likeNumber,
              commentNum: data.commentNumber,
              title: data.title,
              intro: data.introduction,
              channelId: data.channelId,
              channelName: data.channelName,
              channelAvatar: data.channelAvatar,
              alreadyFollow: !!data.isStar,
              lessonId: data.lessonId,
              coursePrice: data.currentPrice,
              liveId: data.liveId
            }
            this.special = !!data.isSelected
            this.isLock = !data.unlock
            this.deblockId = data.liveId
            this.groupQrcode = data.groupQrcode

            this.beforePlay = true

            /*埋点*/
            this.$stat.send({
              name: `直播-页面访问`,
              properties: {
                页面: '回放详情页',
                页面title: this.details.title
              }
            })

            this.$trackPageView('H5_live_details_view', {
              live_id: this.$route.query.id,
              anchor_id: data.channelUserId,
              live_status: '回放'
            })

            // 初始化处理口令
            this.encodeCommand.title = data.title
            this.encodeCommand.desc = data.introduction
            this.encodeCommand.channelName = data.channelName
            this.encodeCommand.url = 'yixinli://open_live_replay?replay_id=' + this.liveId
            this.handleCommand()

            // 设置微信分享信息
            this.shareConfig = {
              shareTitle: data.shareTitle,
              shareContent: data.shareContent,
              shareUrl: data.shareUrl.replace('xinli001.com', 'xinli001.xin') + `&userId=${getUserId() || ''}`,
              shareCover: data.shareCover,
            }
            this.handleWxShare()
            // 设置分享统计信息
            this.statistics = {
              liveId: this.liveId,
              type: this.type
            }

            getLiveDetail({
              liveId: data.liveId,
            }).then(res => {
              this.liveType = res.data.liveType
            })

            this.$nextTick(() => {
              // 控制富文本高度
              this.richTextInit()

              /*初始化阿里播放器，付费课程直播不允许播放*/
              if (this.details.video && +this.details.lessonId === 0) {
                this.handleAliPlayer(data.url)
              }
            })
          }
        })
      },

      checkLiveStatus() {
        clearTimeout(this.checkLiveStatusTimer)
        let token = getToken()
        foreshow({
          liveId: this.liveId,
          token: token,
          code: this.freeCode
        }).then(res => {
          if (+res.code === 0) {
            const data = res.data

            if(data.live.liveStatus === 1 || (data.live.liveStatus === 5 && (data.assistant === 1 || this.isFromAssistant))) {
              this.$router.push({
                path: '/liveDetails',
                query: {
                  ...this.$route.query,
                  id: data.live.id,
                  token,
                  account_id: this.$route.query.account_id || ''
                }
              })
              return
            }
          }
          this.checkLiveStatusTimer = setTimeout(() => this.checkLiveStatus(), 5 * 1000)
        })
      },

      /*获取预告详情页接口*/
      fetchData() {
        let token = getToken()
        foreshow({
          liveId: this.liveId,
          token: token,
          code: this.freeCode
        }).then(res => {
          if (+res.code === 0) {
            const data = res.data
            this.details = {
              video: data.live.advanceVideo,
              videoPreImg: data.live.advanceImg,
              img: data.live.advanceImg,
              likeNum: data.likeNumber,
              commentNum: data.commentNumber,
              title: data.live.advanceTitle,
              intro: data.live.advanceIntro,
              channelId: data.live.channelId,
              channelName: data.channelName,
              channelAvatar: data.shareCover,
              alreadyFollow: data.alreadyFollow,
              alreadyClickRemind: data.alreadyClickRemind,
              advanceDream: data.live.advanceDream,
              advanceConnect: data.live.advanceConnect,
              liveTime: data.live.liveTime,
              liveTitle: data.live.liveTitle,
              lessonId: data.live.lessonId,
              coursePrice: data.currentPrice,
              liveStatus: data.live.liveStatus
            }
            this.special = !!data.isSelected
            this.isLock = !data.unlock
            this.groupQrcode = data.live.groupQrcode

            this.liveTime = timeSplit(data.live.liveTime)
            this.liveType = +data.live.liveType

            /*埋点*/
            this.$stat.send({
              name: `直播-页面访问`,
              properties: {
                页面: '预告详情页',
                页面title: this.details.title
              }
            })

            this.$trackPageView('H5_live_details_view', {
              live_id: this.$route.query.id,
              anchor_id: data.anchorId,
              live_status: '预告'
            })

            window.monitor && window.monitor.stat({
              logType: 'info',
              level: 'info',
              title: '直播-交互行为',
              remark: '访问直播预告页',
              userId: getUserId() || '',
              message: JSON.stringify({
                直播间id: this.$route.query.id,
                页面title: this.details.title,
                liveStatus: this.details.liveStatus,
              })
            })

            /*如果进来页面是已经开播状态则跳去直播详情页*/
            let token = getToken() || ''
            if(data.live.liveStatus === 1 || (data.live.liveStatus === 5 && (data.assistant === 1 || this.isFromAssistant))) {
              this.$router.push({
                path: '/liveDetails',
                query: {
                  ...this.$route.query,
                  id: data.live.id,
                  token,
                  account_id: this.$route.query.account_id || ''
                }
              })
              return
            }

            // 兼容倒计时结束后主播还没开播或者倒计时还没结束，主播就开播
            this.checkLiveStatus()

            // 倒计时为0时重新请求，如liveStatus===1跳到直播页否则跳回列表页
            if (this.isCountEnd) {
              this.handleCountDownEnd(data.live)
              return
            }

            // 初始化处理口令
            this.encodeCommand.title = data.live.liveTitle
            this.encodeCommand.desc = data.live.advanceIntro
            this.encodeCommand.channelName = this.details.channelName
            this.encodeCommand.url = 'yixinli://open_live_notice?live_id=' + this.liveId
            this.handleCommand()

            // 设置微信分享信息
            this.shareConfig = {
              shareTitle: data.shareTitle,
              shareContent: data.shareContent,
              shareUrl: data.shareUrl.replace('xinli001.com', 'xinli001.xin') + `&userId=${getUserId() || ''}`,
              shareCover: data.shareCover,
            }
            this.handleWxShare()
            // 设置分享统计信息
            this.statistics = {
              liveId: this.liveId,
              type: this.type
            }

            // 倒计时
            this.countDown(new Date(res.data.live.liveTime.replace(/-/g, '/')).getTime())

            this.$nextTick(() => {
              // 控制富文本高度
              this.richTextInit()

              /*初始化阿里播放器，付费课程直播不允许播放*/
              if (this.details.video && +this.details.lessonId === 0) {
                this.handleAliPlayer(data.live.advanceVideo)
              }
            })
          }
        })
      },
      /* 获取合集列表 */
      fetchCollectionList() {
        getCollectionList(this.collectionId).then(res => {
          if (+res.code === 0) {
            this.collectionList = res.data.list
            this.$stat.send({
              name: `直播-页面访问`,
              properties: {
                页面: '合集详情页',
                页面title: res.data.collectionName
              }
            })
          }
        })
      },
      /*简介展开收起按钮显示*/
      richTextInit() {
        if(this.$refs.richText) {
          this.$refs.richText.style.lineHeight = '24px'
          this.ifShowExpand = false
          this.isExpand = true
          if (this.$refs.richText.clientHeight / this.$refs.richText.style.lineHeight.replace('px', '') > 2) {
            this.ifShowExpand = true
            this.isExpand = false
          }
        }
      },
      /*阿里播放器处理*/
      handleAliPlayer(source) {
        const isPc = window.$platform.isPc
        if (this.aliplayer) {
          console.log('loadByUrl', source)
          this.isPlay = true
          this.aliplayer.loadByUrl(source)
        } else {
          this.aliplayer = window.Aliplayer({
            id: 'J_prismPlayer_previewDetails',
            width: '100%',
            height: '100%',
            autoplay: false,
            preload: true,
            rePlay: !this.isReplay,
            skinLayout: [
              {
                name: "H5Loading", align: "cc"
              },
              {name: "bigPlayButton", align: "cc"},
              {name: "infoDisplay"},
              {
                name: "controlBar", align: "blabs", x: 0, y: 0,
                children: [
                  {name: "progress", align: "tlabs", x: 0, y: 4},
                  {name: "playButton", align: "tlabs", x: isPc ? 24 : 20, y: isPc ? 28 : 20},
                  {name: "timeDisplay", align: "tlabs", x: isPc ? 54 : 50, y: isPc ? 21 : 13},
                ]
              }
            ],
            controlBarVisibility: isPc ? 'always' : 'click',
            components: [{
              name: 'RateComponent',
              type: AliPlayerComponent.RateComponent
            }],
            playsinline: false,
            x5_type: 'h5',
            x5_fullscreen: true,
            x5_orientation: 'portraint',
            source
          })

          if (this.isCollection) {
            this.aliplayer.on('ended', () => {
              console.log('end')
              if (this.currentCollectionIdx < this.collectionList.length - 1) {
                this.currentCollectionIdx++
              }
            })
          }

          this.aliplayer.on('error', function(e) {
            console.log('错误', e)
          })
          // this.playListener()
        }
        this.aliplayer.on('ready', () => {
          console.log('准备')
          if (this.initialization) {
            setTimeout(() => {
              this.beforePlay = false
              this.aliplayer.play()
            }, 1000)
          }
          aliplayerReadyHandle()

          if (!this.viewable && this.isReplay) {
            if (!this.isCollection) {
              this.aliplayer.on('timeupdate', () => {
                let time = this.aliplayer.getCurrentTime()
                if (time >= 30) {
                  this.aliplayer.pause()
                  this.isPlay = false
                  if (getToken()) {
                    this.$toast('您尚未解锁视频，请解锁后观看')
                  } else {
                    this.$toast({
                      text: '登录后观看更多',
                      callback: this.handlewxLogin
                    })
                  }
                }
              })
            }
            this.aliplayer.setPreviewTime(30)
          } else {
            this.aliplayer.setPreviewTime(null)
            // this.aliplayer.off('timeupdate')
          }

          /*动态设置video的适应object-fit*/
          this.fitVideo()

          this.aliplayer.off('ready')
        })
        this.aliplayer.on('pause', () => {
          this.$stat.send({
            name: '直播-交互行为',
            properties: {
              业务: '直播预告',
              行为: '点击',
              对象: '暂停',
              页面: this.isReplay ? '回放详情页' : '预告详情页',
              页面title: this.details.title
            }
          })
          clearTimeout(this.statisticalDurationTimer)
          this.statisticalDurationPost()
        })
        this.aliplayer.on('play', () => {
          this.$stat.send({
            name: '直播-交互行为',
            properties: {
              业务: '直播预告',
              行为: '点击',
              对象: '播放',
              页面: this.isReplay ? '回放详情页' : '预告详情页',
              页面title: this.details.title
            }
          })
          if (this.beforePlay) { // 这里把视频长宽与播放前显示的图片长宽解耦，防止img继承video的适配
            this.beforePlay = false
          }
          if (!this.wifiTips && !isWifi()) {
            this.$toast('非wifi状态消耗流量')
            this.wifiTips = true
          }
          this.playTime = new Date().getTime()
          this.statisticalDuration()
        })
      },
      /*点击功能键以外的地方控制暂停播放，需要排除的功能键加一个class='func-btn'*/
      playListener() { // 暂停播放监听
        document.getElementsByClassName('pre-content')[0].addEventListener('click', (event) => {
          if (!Array.from(event.target.classList).includes('func-btn') && event.target.tagName !== 'use') {
            if (this.isPlay) {
              this.$stat.send({
                name: '直播-交互行为',
                properties: {
                  业务: '直播预告',
                  行为: '点击',
                  对象: '暂停',
                  页面: this.isReplay ? '回放详情页' : '预告详情页',
                  页面title: this.details.title
                }
              })
              this.aliplayer.pause()
            } else {
              this.$stat.send({
                name: '直播-交互行为',
                properties: {
                  业务: '直播预告',
                  行为: '点击',
                  对象: '播放',
                  页面: this.isReplay ? '回放详情页' : '预告详情页',
                  页面title: this.details.title
                }
              })
              this.aliplayer.play()
              if (this.beforePlay) { // 这里把视频长宽与播放前显示的图片长宽解耦，防止img继承video的适配
                this.beforePlay = false
              }
              if (!this.wifiTips && !isWifi()) {
                this.$toast('非wifi状态消耗流量')
                this.wifiTips = true
              }
            }
            this.isPlay = !this.isPlay
          }
        })
      },
      switchVideo(index) {
        this.currentCollectionIdx = index
      },
      showComment() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '查看评论',
            页面: this.isReplay ? '回放详情页' : '预告详情页',
            页面title: this.details.title
          }
        })
        this.getCommentList()
        this.commentDialog = !this.commentDialog
      },
      /*简介展开收起控制*/
      handleExpandBtn() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: this.isExpand ? '收起' : '展开',
            被点击的文字: this.isExpand ? '收起' : '展开',
            页面: this.isReplay ? '回放详情页' : '预告详情页',
            页面title: this.details.title
          }
        })
        this.isExpand = !this.isExpand
      },
      getCommentList() {
        this.loading = true
        getCommentList({
          objectId: this.liveId, // 直播间id
          objectName: this.isReplay ? 'live.replay' : 'live',
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          parentId : 0
        }).then(({code, data}) => {
          if (code === 0) {
            this.commentList = this.commentList.concat(data.list)
            this.totalCount = data.totalCount
            this.totalPage = data.totalPage
            this.pageNo++
            // 关闭正在加载中
            this.loading = false
            // 如果没有更多数据，则加载完成
            if (this.pageNo > data.totalPage) {
              this.finish = true
              return
            }
          }
        })
      },
      handleRemind() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '点击开播提醒',
            页面: '预告详情页',
            页面title: this.details.title
          }
        })
        if (this.details.alreadyClickRemind) {
          return
        }
        let token = getToken()
        let openId = getOpenId()
        if (token) {
          remind({liveId: this.liveId, token, openId}).then(res => {
            if (+res.code === 0) {
              this.details.alreadyClickRemind = true
              this.previewDialog = true
            }
          })
        } else {
          this.handlewxLogin()
        }
      },
      handleAttention() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: this.details.alreadyFollow ? '取消关注频道' : '关注频道',
            被点击的文字: this.details.alreadyFollow ? '已关注的图标' : '关注',
            页面: this.isReplay ? '回放详情页' : '预告详情页',
            页面title: this.details.title
          }
        })
        let token = getToken()
        let open_id = getOpenId()
        if (token) {
          starChannel({
            channelId: this.details.channelId,
            isStar: this.details.alreadyFollow ? 0 : 1,
            token,
            openId: open_id,
            liveId: this.type === 3 ? this.details.liveId : this.liveId,
            type: this.type
          }).then(res => {
            if (+res.code === 0) { // 关注成功弹框提示
              if (!this.details.alreadyFollow) {
                this.attentionDialog = true
              }
              this.details.alreadyFollow = !this.details.alreadyFollow
            }
          })
        } else {
          this.handlewxLogin()
        }
      },
      /*倒计时结束跳转页面处理*/
      handleCountDownEnd(live) {
        console.log(`livelivelive`, live)
        if (live.liveStatus === 1) {
          let token = getToken()
          this.$router.push({
            path: '/liveDetails',
            query: {
              id: live.id,
              token,
              account_id: this.$route.query.account_id || ''
            }
          })
        } else {
          const toList = !this.isToufangLive
          const lastix = toList ? '，立即前往列表页发现更多精彩' : ''
          if (live.liveStatus === 0 || live.liveStatus === 5) {
            this.$toast('直播尚未开始' + lastix)
          } else if (live.liveStatus === 2) {
            this.$toast('本场直播已结束' + lastix)
          }
          if (toList) {
            const timeout = setTimeout(() => {
              clearTimeout(timeout)
              this.$router.push('/')
            }, 2000)
          }
        }
      },
      countDownEnd() {
        this.isCountEnd = true
        this.fetchData()
      },
      dreamApply() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '解梦申请按钮',
            被点击的文字: '解梦申请',
            页面: '预告详情页',
            页面title: this.details.title
          }
        })
      },
      microConnectApply() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '连麦申请按钮',
            页面: '预告详情页',
            页面title: this.details.title
          }
        })
      },
      likeClick() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: this.isReplay ? '点赞' : '内容点赞',
            页面: this.isReplay ? '回放详情页' : '预告详情页',
            页面title: this.details.title
          }
        })
      },
      watchClick() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '主播邀你来观看直播入口',
            页面: '预告详情页',
            页面title: this.details.title
          }
        })
      },
      goToAppReplay() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '去壹心理App观看精彩视频>>>',
            页面: '回放详情页',
            页面title: this.details.title
          }
        })
      },
      closePreviewDialog() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '关闭二维码弹框',
            页面: '预告详情页',
            页面title: this.details.title
          }
        })
        this.previewDialog = false
      },
      closeAttentionDialog() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '关闭二维码弹框',
            页面: this.isReplay ? '回放详情页' : '预告详情页',
            页面title: this.details.title
          }
        })
        this.attentionDialog = false
      },
      closeReplayDialog() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '观看弹窗点击取消',
            页面: '回放详情页',
            页面title: this.details.title
          }
        })
        this.replayDialog = false
      },
      replayConfirmBtn() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '观看弹窗点击确定',
            页面: '回放详情页',
            页面title: this.details.title
          }
        })
      },
      update(to) {
        /*修改title为回放详情*/
        if (REPLAY.includes(to.query.type)) {
          setTimeout(() => {
            document.title = '回放详情'
          })
        }
      },

      // 统计回放时长
      statisticalDuration() {
        this.statisticalDurationTimer = setTimeout(() => {
          this.statisticalDurationPost().then(this.statisticalDuration)
        }, 5000)
      },

      statisticalDurationPost() {
        const token = getToken()
        const userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
        const nickname = getStorage('live-wx-nickname') || (userInfo && userInfo.nickname) || this.userInfo.nickname
        if (!token || !nickname) return Promise.reject()
        const currTime = new Date().getTime()
        const duration = Math.round((currTime - this.playTime) / 1000)
        this.playTime = currTime
        return liveRecordedView({
          token: token,
          nickname: nickname,
          liveId: this.details.liveId,
          duration: duration
        })
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //回调函数，此时this指针不可用，可采用回调函数访问。
        vm.update(to);
      })
    },
    beforeDestroy() {
      clearTimeout(this.checkLiveStatusTimer)
      clearTimeout(this.statisticalDurationTimer)
      this.aliplayer && this.aliplayer.dispose()
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  /deep/ .prism-player {
    background: transparent;

    .prism-controlbar {
      height: 120px;

      .prism-controlbar-bg {
        height: 100%;
      }

      .prism-progress {
        left: 40px !important;
        right: 40px !important;
        width: auto;
        border-radius: 8px;

        .prism-progress-loaded, .prism-progress-played, .prism-progress-marker {
          border-radius: 8px;
        }

        .prism-progress-played {
          background-color: #fff;
        }
      }

      .rate-components {
        position: absolute;
        right: 34px;
        top: 24px;
      }
    }
  }

  .aliplayer-contain {
    /deep/ video {
      object-fit: contain !important;
    }
  }

  .aliplayer-cover {
    /deep/ video {
      object-fit: cover !important;
    }
  }

  .comment-tip {
    margin: 20px 0 30px 0;
    text-align: center;
  }

  .preview-container {
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    color: #fff;
    font-size: 26px;
    background: #000;

    .pre-video {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .prevideo-img {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;

      img {
        width: 100%;
      }
    }

    .pre-img {
      width: 100%;
    }

    .play-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;
    }

    // .pre-content {
    //   position: absolute;
    //   height: 100%;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    //   top: 0;
    // }

    .section {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 30px 30px 120px;

      background-image: linear-gradient(0deg, rgba(0,0,0,.3) 0%, rgba(0,0,0,0.00) 100%);
      pointer-events: none;

      .section-bottom {
        position: absolute;
        bottom: 170px;
        left: 30px;
        right: 30px;
        pointer-events: all;
      }
    }
  }

  .preview-time-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -345px;
    padding: 16px 20px;
    margin-top: 30px;
    width: 650px;

    background: rgba(0,0,0,0.30);
    border-radius: 20px;
    font-family: DharmaTypeBebasKai, PingFangSC-Regular, 'Helvetica';

    .time-left-con {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .preview-tag {
      margin-right: 20px;
      padding: 4px 14px;

      background-image: linear-gradient(-56deg, #6982FA 0%, #69A7FA 100%);
      border-radius: 10px;
    }

    .time-box {
      display: inline-block;
      width: 40px;
      height: 40px;
      margin: 0 8px;
      text-align: center;
      line-height: 40px;

      border: 2px solid #FFFFFF;
      border-radius: 8px;
      color: #fff;
    }

    .oval-box1,
    .oval-box2 {
      margin-left: 14px;
      width: 120px;
      height: 48px;
      text-align: center;
      line-height: 48px;

      border-radius: 24px;
      font-size: 22px;
    }

    .oval-box1 {
      font-size: 22px;
      border: 0;
      background: rgba(0, 0, 0, .3);
    }

    .oval-box2 {
      background-image: linear-gradient(121deg, #FF8A74 0%, #6982FA 100%);
    }
  }

  .text-container {

    .title {
      padding: 20px 0;
      font-size: 32px;
      @include overLine(1);
      &.special {
        padding-left: 102px;
        background: url('../../assets/images/icon-special.png') no-repeat left / 82px 42px;
      }
    }

    .rich-text {
      max-height: calc(100vh - 650px);
      overflow-y: auto;
      font-size: 26px;
      white-space: pre-wrap;
    }

    .expand-text {
      position: relative;
      @include overLine(2);
    }

    .operate-btn {
      padding: 10px 10px 0 0;
      float: left;
    }
  }

  .preview-fun-container {
    display: flex;
    justify-content: space-between;

    .left-btn,
    .replay-btn {
      padding: 16px 24px;

      border-radius: 36px;
      background-color: rgba(0, 0, 0, .3);
      color: rgba(255, 255, 255, .8);
      font-size: 28px;

      .svg-icon {
        margin-bottom: 3px;
        fill: #fff;
        font-size: 18px;
      }
    }

    .replay-btn {
      background-color: #fff;
      font-family: PingFangSC-Medium;
      color: #6982FA;

      .svg-icon {
        fill: #6982FA;
      }
    }

    .btn-group {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .bottom-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 0 15px;
        width: 72px;
        height: 72px;

        border-radius: 50%;
        background-color: rgba(0, 0, 0, .3);

        .tag {
          position: absolute;
          top: 0px;
          right: -24px;
          width: 40px;
        }

        .num {
          position: absolute;
          top: -14px;
          height: 24px;
          padding: 0 12px;
          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 18px;
          background: #FF4A4A;
          border-radius: 12px;
        }

        img {
          width: 36px;
        }
      }
    }

    .bottom-group-comment-only {
      flex: 1;
      justify-content: flex-end;
    }
  }

  .dialog-content {
    .replay-tip {
      width: 400px;
    }

    .conteng-title {
      font-size: 38px;
      color: #21252D;
      font-weight: bold;
    }

    .content-subheading {
      padding-top: 20px;
      font-size: 28px;
      color: #6C798C;
      line-height: 48px;

      span {
        color:  #6982FA;
      }
    }

    .content-tip {
      padding: 48px 0 30px 0;
      font-size: 26px;
      color: #6C798C;
      line-height: 48px;
    }

    .content-scan {
      width: 300px;
      height: 300px;
      margin: 0 auto;

      .scan-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .comment-top-title {
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 28px;
    color: #21252d;
  }

  .course-con {
    max-width: 10rem;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
  }
</style>
